module.exports = "<p>event-based-log works!</p>\n"